try {
    new Function("let abc = 'def';");
} catch (err) {
    alert('Error! Your browser is too old!');
}

require('./bootstrap');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import { createApp } from 'vue';

// Import and start Alpine
import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

const app = createApp({});

app.component(
    'responsive-navigation',
    require('./components/ResponsiveNavigation.vue').default
);
app.component(
    'drain-map-adopt',
    require('./components/DrainMapAdopt.vue').default
);
app.component(
    'drain-map-home',
    require('./components/DrainMapHome.vue').default
);
app.component(
    'drain-map-suggest',
    require('./components/DrainMapSuggest.vue').default
);
app.component('map-only', require('./components/MapOnly.vue').default);

app.component('image-upload', require('./components/ImageUpload.vue').default);

app.component(
    'how-to-clean-a-drain-carousel',
    require('./components/HowToCleanADrainCarousel.vue').default
);
app.component(
    'why-adopt-a-drain-carousel',
    require('./components/WhyAdoptADrainCarousel.vue').default
);
app.component(
    'activity-feed',
    require('./components/ActivityFeed.vue').default
);
app.component(
    'kiosk-mode-refresh-timer-modal',
    require('./components/KioskModeRefreshTimerModal.vue').default
);

app.mount('#app');
